import {
  WorkbookReportTypeName,
  ReportDescriptor,
  reportOptions,
} from "@framework/types/workbook-report"

export const reportOptionsMap: Record<
  WorkbookReportTypeName,
  ReportDescriptor
> = {
  SEARCH_QUERY: {
    type: "SEARCH_QUERY",
    displayName: "Search Query",
    message: "Search",
    icon: "search",
  },
  UPCROSSSELLOPPORTUNITY: {
    type: "UPCROSSSELLOPPORTUNITY",
    displayName: "Up and Cross Sell Opportunities",
    message: "Generate a report for up sell and cross sell opportunities",
    icon: "file-chart",
  },
  ACCOUNTPLAN: {
    type: "ACCOUNTPLAN",
    displayName: "Account Plan",
    message: "Generate an Account plan report",
    icon: "file-chart",
  },
  DOCUMENTCOMPLIANCE: {
    type: "DOCUMENTCOMPLIANCE",
    displayName: "Document Compliance",
    message: "Generate a document compliance report",
    icon: "file-chart",
  },
  PRODUCTCOMPARISON: {
    type: "PRODUCTCOMPARISON",
    displayName: "Product Comparison",
    message: "Generate a comparison report for two or more products",
    icon: "scales",
  },
  PRODUCTPOSITIONING: {
    type: "PRODUCTPOSITIONING",
    displayName: "Product Positioning",
    message:
      "Create Product Positioning report for a target product against other products",
    icon: "positioning",
  },
  PRODUCTRECOMMENDATION: {
    type: "PRODUCTRECOMMENDATION",
    displayName: "Product Recommendation",
    message:
      "Generate product recommendation report for a target application, scenario or metrics.",
    icon: "recommendation",
  },
}

export const getReportDescriptionByType = (
  reportType: WorkbookReportTypeName
) => reportOptionsMap[reportType]

export const isWorkbookReportTypeName = (
  candidate: string
): candidate is WorkbookReportTypeName =>
  reportOptions.includes(candidate as any)
